module.exports = __webpack_public_path__ + "static/img/bg_3_2.12ee01a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_3_2.png
// module id = Pz3y
// module chunks = 3